import { useEffect, useRef, useState } from "react";

/* Quiet rotating announcement strip (login pages).
   Gentle fade every ~6s, pauses on hover; prefers-reduced-motion shows only
   the first line statically. Accent ticks follow var(--brand-accent). */
export default function AnnouncementTicker({ lines = [], className = "", interval = 6000 }) {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);
  const hovered = useRef(false);
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    if (reduced || lines.length < 2) return undefined;
    const t = setInterval(() => {
      if (hovered.current) return;
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % lines.length);
        setVisible(true);
      }, 350);
    }, interval);
    return () => clearInterval(t);
  }, [lines.length, interval, reduced]);

  if (!lines.length) return null;
  const line = lines[reduced ? 0 : idx % lines.length];

  return (
    <div className={`flex items-center justify-center gap-2.5 ${className}`}
      data-testid="login-announcement"
      onMouseEnter={() => { hovered.current = true; }}
      onMouseLeave={() => { hovered.current = false; }}>
      <span className="h-px w-5 shrink-0" style={{ background: "var(--brand-accent)" }} />
      <p className="text-[10.5px] uppercase tracking-[0.16em] text-slate-400 text-center transition-opacity duration-300"
        style={{ opacity: visible ? 1 : 0 }} data-testid="login-announcement-line">
        {line}
      </p>
      <span className="h-px w-5 shrink-0" style={{ background: "var(--brand-accent)" }} />
    </div>
  );
}
